



































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { ClaimEnum } from '../../services/ClaimEnum';

@Component
export default class ProcessesWidget extends Vue {
    processList: any = [];
    connection: any;
    loading: boolean = false;
    get areProcessesActive(): boolean {
        return (this.processList.length > 0);
    }
    get isAuthorized(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanUploadDocument);
    }
    beforeDestroy() {
        //this.connection.stop();
    }

    mounted() {
        if (this.isAuthorized) this.refresh();
        /*app.processList = [{
            Percentage: 80,
            Username: 'schinelli'
        }]*/
    }
    refresh() {
        let app = this;
        this.loading = true;
        axios({
            method: 'get',
            url: General.GetApiUrl('/api/process/GetProcessList'),
            withCredentials: true,
            responseType: 'json'
        })
            .then(({ data }) => {

                app.processList = data;
                app.loading = false;
            }).catch(error => {
                General.HandleError(error, app);
            });;
    }
    killAll() {
        let app = this;
        this.$bvModal.msgBoxConfirm('Do you confirm kill all processes?').then(value => {
            if (value) {
                app.loading = true;
                axios({
                    method: 'get',
                    url: General.GetApiUrl('/api/process/KillProcessList'),
                    withCredentials: true,
                    responseType: 'text'
                }).then(({ data }) => {
                    app.loading = false;
                });
            }
        });
    }

    reset() {
        /*
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();

        let app = this;
        this.connection.on("status", data => {
            var dataParsed = JSON.parse(data);

            app.processList = dataParsed;

        });

        this.connection.start();
        */
    }
}
